import React from "react";
import PropTypes from "prop-types";

export default function HeaderCenter({
  image,
  title,
  text,
}) {
  return (
    <>
      <section className="pt-20 pb-12 flex relative items-center p-0 min-h-screen-50 z-0">
        <div className="absolute w-full h-full block opacity-50 z-1 left-0 top-0"></div>
        <div
          className="w-full h-full absolute bg-cover bg-50"
          style={{
            backgroundImage: "url('" + image + "')",
          }}
        ></div>
        <div className="relative h-full text-center text-black container mx-auto px-4 z-2">
          <div className="justify-center flex flex-wrap">
            <div className="px-12 px-4 relative w-full md:w-10/12">
              <h1 className="text-5xl border-b p-4 font-bold leading-tight mt-0 mb-2 text-center">
                {title}
              </h1>
              <p className="text-xl leading-relaxed opacity-75 mt-1 mb-4 text-center">
                {text}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

HeaderCenter.propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  text: PropTypes.string,
};
